import { Styles } from "jspdf-autotable";

export const getFonts = (font: string) => {
  const normalFontSize = 12;
  const bigFontSize = 14;

  const normalFontStyles: Partial<Styles> = {
    fontSize: normalFontSize,
    font,
    fontStyle: "bold"
  };
  const bigFontStyles: Partial<Styles> = {
    fontSize: bigFontSize,
    font,
    fontStyle: "bold"
  };

  return {
    normalFontSize,
    normalFontStyles,
    bigFontSize,
    bigFontStyles
  };
};
